// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   TextField,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Typography,
//   Button,
//   Box,
//   Modal,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import "./FAQ.css";
// import GotQuestions from "../static/GotQuestions.png";
// import Nodata from "../static/Nodata.png";
// import SearchIcon from "@mui/icons-material/Search";
// import InputAdornment from "@mui/material/InputAdornment";
// import VideoModel from "./VideoModel";
// import Grammar from "../static/Grammar.mp4";
// import ParaphraserVideo from "../static/ParaphraserVideo.mp4";
// import PlagiarismVideo from "../static/PlagiarismVideo.mp4";
// import TeamsVideo from "../static/TeamsVideo.mp4";
// import TranslatorVideo from "../static/TranslatorVideo.mp4";
// import CoAuthor1Video from "../static/CoAuthor1Video.mp4";
// import { sendQuestions } from "../services/userService";
// import { toast } from "react-toastify";
// import { getVideoUrl } from "../services/document";
// import { addUserLogs } from "../services/userLogServices";

// const faqData = [
//   {
//     question: "How do I upload a document for grammar checking?",
//     answer:
//       "You can upload a document by clicking on the Upload button on the homepage, then selecting the file from your device.",
//   },
//   {
//     question: "How does the grammar check feature work?",
//     answer:
//       "The grammar check feature scans your document for errors and provides suggestions for corrections in real-time.",
//     videoUrl: "Grammar.mp4",
//   },
//   {
//     question: "Can I customize the suggestions provided by the grammar check?",
//     answer:
//       "Yes, you can customize suggestions by adjusting the settings in the references section.",
//   },
//   {
//     question: "How do I use the paraphrasing tool?",
//     answer:
//       "Paste your text into the paraphrasing tool and select the paraphrase button to get rewritten content.",
//     videoUrl: "ParaphraserVideo.mp4",
//   },
//   {
//     question:
//       "What options are available for setting the tone in paraphrasing?",
//     answer:
//       "You can choose from various predefined tones like formal, casual, or professional from the tone settings.",
//     videoUrl: "ParaphraserVideo.mp4",
//   },
//   {
//     question: "How can I summarize a long document?",
//     answer:
//       "Upload your document and select the Summarize option to get a concise summary of your content.",
//   },
//   {
//     question: "Is it possible to translate documents to multiple languages?",
//     answer:
//       "Yes, you can translate documents into multiple languages by using the Translator feature and selecting the desired language.",
//   },
//   {
//     question: "How do I navigate to the blogs page?",
//     answer:
//       "You can find the blogs page in the main menu under the Resources section.",
//   },
//   {
//     question: "Can I write and publish my own blogs?",
//     answer:
//       "Yes, you can write and submit your blogs for approval, and once approved they will be published on the platform.",
//   },
//   {
//     question: "How do I create or join a team?",
//     answer:
//       "Navigate to the Teams page, where you can create a new team or join an existing one by invitation.",
//     videoUrl: "TeamsVideo.mp4",
//   },
//   {
//     question: "What features are available on the Teams page?",
//     answer:
//       "The Teams page allows for group chats, document sharing, and collaborative editing.",
//     videoUrl: "TeamsVideo.mp4",
//   },
//   {
//     question: "How do I check for plagiarism in my document?",
//     answer: "Upload your document and use the Plagiarism Checks feature to scan for any copied content.",
//     videoUrl: "PlagiarismVideo.mp4",
//   },
//   {
//     question: "How do I save my document after editing?",
//     answer:
//       "Click on the Save button in the document editor to save your changes.",
//   },
//   {
//     question: "Can I download my document after editing it on the platform?",
//     answer:
//       "Yes, you can download your edited document in various formats like PDF or Word.",
//   },
//   {
//     question: "How do I get notified about changes or comments on document?",
//     answer:
//       "Enable notifications in your account settings to receive updates on changes or comments on your document.",
//   },
//   {
//     question: "Is there a limit to the number of documents i can upload?",
//     answer:
//       "There is no limit to the number of documents you can upload; however storage space may vary based on your subscription plan.",
//   },
//   {
//     question: "How do I access my previously uploaded documents?",
//     answer:
//       "Go to the My Documents section in your account to access all your uploaded documents.",
//   },
//   {
//     question: "Can I collaborate with others on a document?",
//     answer:
//       "Yes, you can share your document with team members and collaborate in real-time.",
//     videoUrl: "CoAuthor1Video.mp4",
//   },
//   {
//     question: "How do I change my account settings?",
//     answer:
//       "Navigate to Account Settings in the main menu to update your preferences and personal information.",
//   },
//   {
//     question: "Where can I find tutorials or help guides?",
//     answer:
//       "You can find the blogs page in the main menu under the Resources section.",
//   },
// ];

// const FAQ = () => {
//   const [search, setSearch] = useState("");
//   const [question, setQuestion] = useState("");
//   const [open, setOpen] = useState(false);
//   const [videoUrl, setVideoUrl] = useState("");
//   const [noResultsDialogOpen, setNoResultsDialogOpen] = useState(false);
//   const email = sessionStorage.getItem("currentUserEmail");
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [isDarkMode, setIsDarkMode] = useState(false);
//   useEffect(() => {
//       const updateTheme = () => {
//         const theme = localStorage.getItem('ThemeSwitch');
//         setIsDarkMode(theme === 'true');
//       };
//       updateTheme();
//       window.addEventListener('storage', updateTheme);
//       const originalSetItem = localStorage.setItem;
//       localStorage.setItem = function (key, value) {
//         originalSetItem.apply(this, arguments);
//         if (key === 'ThemeSwitch') {
//           updateTheme();
//         }
//       };
//       return () => {
//         window.removeEventListener('storage', updateTheme);
//         localStorage.setItem = originalSetItem;
//       };
//     }, []);
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const handleSearchChange = (e) => {
//     setSearch(e.target.value);
//   };

//   const handleQuestionChange = (e) => {
//     setQuestion(e.target.value);
//   };
//   function arrayBufferToBase64(arrayBuffer) {
//     let binary = '';
//     const bytes = new Uint8Array(arrayBuffer);
//     const len = bytes.byteLength;
//     for (let i = 0; i < len; i++) {
//       binary += String.fromCharCode(bytes[i]);
//     }
//     return window.btoa(binary);
//   }

//   const handleOpen = async (fileName) => {
//     try {
//       const { blob, contentType } = await getVideoUrl(fileName);
//       const arrayBuffer = await blob.arrayBuffer();
//       const base64String = arrayBufferToBase64(arrayBuffer);
//       const videoUrl = `data:${contentType};base64,${base64String}`;
//       setVideoUrl(videoUrl);
//       setOpen(true);
//     } catch (error) {
//       console.error("Error fetching video URL:", error);
//       toast.error("Failed to retrieve video URL");
//     }
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setVideoUrl("");
//   };
//   const handleNodataClose = () => {
//     setNoResultsDialogOpen(false);
//     setManualClose(true);
//   };

//   const handleSubmit = async () => {
//     if (!question) {
//       toast.warn("Please enter your question.");
//     } else {
//       let details = {
//         userEmail: email,
//         message: question,
//       };
//       console.log(details);
//       let response = await sendQuestions(details);
//       console.log(response);
//       if (response.status === 200) {
//         toast.success(response.message);
//         const data = {
//           userId: sessionStorage.getItem("userId"),
//           organizationId: sessionStorage.getItem("organizationId"),
//           actionType: "sendQuestion",
//         };

//         const addLogs = await addUserLogs(data);
//         if (addLogs.status !== 200) {
//           toast.error(addLogs.message);
//         }
//       } else {
//         toast.error(response.message);
//       }
//     }
//     setQuestion("");
//   };

//   const filteredFaqs = faqData.filter((faq) =>
//     faq.question.toLowerCase().includes(search.toLowerCase())
//   );
//   const [manualClose, setManualClose] = useState(false);

//   useEffect(() => {
//     if (filteredFaqs.length === 0 && !manualClose) {
//       setNoResultsDialogOpen(true);
//     }
//   }, [filteredFaqs, manualClose]);

//   useEffect(() => {
//     if (filteredFaqs.length > 0) {
//       setManualClose(false);
//     }
//   }, [filteredFaqs]);
//   return (
//     <Container className="faq-container">
//       <div className="faqpage" style={{flexDirection: windowWidth > 767 ? "row" : "column-reverse"}}>
//         <div className="leftcontent"  style={{width: windowWidth > 767 ? "50%" : "100%",padding:windowWidth<=767?"5px":'20px'}}>
//           <Typography className="main-title" variant="h4" gutterBottom>
//             Frequently Asked Questions
//           </Typography>
//           {windowWidth < 601 &&
//           <div style={{color: isDarkMode?"white":"#1976d2", fontSize:"1.6rem", marginBottom: "15px"}}>
//             Frequently Asked Questions
//           </div>}
//           <TextField
//             label="Search"
//             variant="outlined"
//             fullWidth
//             value={search}
//             onChange={handleSearchChange}
//             sx={{
//               marginBottom: "20px",
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: "20px",
//                 backgroundColor: isDarkMode ? "#141414" : "",
//                 "& fieldset": {
//                   borderColor: isDarkMode ? "gray" : "default",
//                   borderRadius: "20px",
//                 },
//               },
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <SearchIcon sx={{ color: isDarkMode ? "white" : "#1976d2" }} />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <div className="faqCards" style={{paddingRight: windowWidth > 767 ? "10px" : "0px"}}>
//             {filteredFaqs.length > 0 ? (
//               filteredFaqs.map((faq, index) => (
//                 <Accordion
//                   key={index}
//                   sx={{
//                     position: "relative",
//                     marginTop: "15px",
//                     border: "1px solid #ccc",
//                     backgroundColor: isDarkMode ? "#141414" : "white", // Darker shade close to black
//                     borderRadius: "15px",
//                     boxShadow: "rgba(0, 0, 0, 0.5) 0px 3px 8px",
//                     overflow: "hidden",
//                     "&::before": {
//                       content: '""',
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "8px",
//                       height: "100%",
//                       backgroundColor: "#1976d2",
//                       zIndex: 1,
//                     },
//                   }}
//                 >
//                   <AccordionSummary
//                     expandIcon={<ExpandMoreIcon sx={{ color: isDarkMode ? "white" : "#1976d2", }} />}
//                     sx={{
//                       backgroundColor: isDarkMode ? "#141414" : "white", // Darker shade of summary
//                       border: "1px solid #ccc",
//                       padding: "10px 15px",
//                       borderRadius: "15px",
//                     }}
//                   >
//                     <Typography sx={{ color: isDarkMode ? "white" : "#1976d2", fontWeight: isDarkMode?'normal': "bold" }}>
//                       {faq.question}
//                     </Typography>
//                   </AccordionSummary>
//                   <AccordionDetails
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "flex-start",
//                       padding: "15px",
//                       backgroundColor: isDarkMode ? "#141414" : "white", // Darker shade for details
//                       border: "1px solid #ccc",
//                       borderRadius: "15px",
//                     }}
//                   >
//                     <Typography sx={{ color: isDarkMode ? "white" : "black", fontWeight:isDarkMode?'normal':'' }}>{faq.answer}</Typography>
//                     {faq.videoUrl && (
//                       <button
//                         className="sendButton"
//                         style={{marginTop:'10px', width:'120px'}}
//                         onClick={() => handleOpen(faq.videoUrl)}
//                       >
//                         View Demo
//                       </button>
//                     )}
//                   </AccordionDetails>
//                 </Accordion>
//               ))
//             ) : (
//               <Modal
//                 open={noResultsDialogOpen}
//                 onClose={handleNodataClose}
//                 aria-labelledby="no-results-title"
//                 aria-describedby="no-results-description"
//               >
//                 <Box className="noSearchDialogContainer">
//                   <Box className="noSearchDialogContent">
//                     <img src={Nodata} className="noSearchImage" alt="No Data" />
//                     <Typography id="no-results-title" className="noSearchTitle">
//                       {"We couldn't find an answer to your question."}
//                     </Typography>
//                     <Typography
//                       id="no-results-description"
//                       className="NosearchSubtitle"
//                       sx={{ color: isDarkMode?"lightgray":'' }}
//                     >
//                       Would you like to ask us directly? Please reach out to us
//                       to submit your question.
//                     </Typography>
//                     <Box className="noSearchDialogActions">
//                       <Button onClick={handleNodataClose} variant="outlined">
//                         No Thanks
//                       </Button>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Modal>
//             )}
//           </div>
//         </div>
//         <div className="rightcontent" style={{width: windowWidth > 767 ? "50%" : "100%", marginLeft: windowWidth > 767 ? "30px" : "0px",marginBottom: windowWidth > 767 ? "0px" : "20px"}}>
//           <div style={{display: windowWidth > 767 ? "block" : "none"}}>
//             <img src={GotQuestions} alt="FAQ Image" className="faqImage" />
//           </div>
//           <Box className="questionBox" style={{width: windowWidth > 767 ? "90%" : "100%",}}>
//             <Typography className="questionTitle" style={{fontSize: windowWidth > 767 ? "25px" : "2.125rem" }}>Got Questions?</Typography>
//             <Typography
//               className="questionSubtitle"
//               variant="subtitle1"
//               gutterBottom
//             >
//               Reach out anytime! Our team is ready to assist.
//             </Typography>
//             <TextField
//               label="Enter your question"
//               variant="outlined"
//               fullWidth
//               multiline
//               rows={4}
//               value={question}
//               onChange={handleQuestionChange}
//               className="questionField"
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": {
//                     borderColor: isDarkMode ? "gray" : "default",
//                   },
//                 }
//               }}
//             />
//           </Box>
//           <div className="sendbtn" style={{ width: windowWidth > 767 ? undefined : "100%"}}>
//             <button
//               onClick={handleSubmit}
//               className="sendButton"
//               style={{width : windowWidth > 767 ? "110px" : "100%"}}
//             >
//               Send
//             </button>
//           </div>
//         </div>
//       </div>
//       <VideoModel open={open} handleClose={handleClose} videoUrl={videoUrl} isDarkMode={isDarkMode} />
//     </Container>
//   );
// };

// export default FAQ;

import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Box,
  Modal,
  Paper,
  InputAdornment,
  Fade,
  IconButton,
  Avatar,
  Chip,
  Badge,
  Tooltip,
  Zoom,
  Card,
  Divider,
  Slide,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import QuizIcon from "@mui/icons-material/Quiz";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import TranslateIcon from "@mui/icons-material/Translate";
import GroupIcon from "@mui/icons-material/Group";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import SummarizeIcon from "@mui/icons-material/Summarize";
import PlagiarismIcon from "@mui/icons-material/Plagiarism";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import MinimizeIcon from "@mui/icons-material/Minimize";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

// Mock imports - replace with your actual imports
import GotQuestions from "../static/GotQuestions.png";
const Nodata = "https://via.placeholder.com/200x200?text=No+Data";

const faqData = [
  {
    question: "How do I upload a document for grammar checking?",
    answer:
      "You can upload a document by clicking on the Upload button on the homepage, then selecting the file from your device.",
    category: "Upload",
    icon: <UploadFileIcon />,
  },
  {
    question: "How does the grammar check feature work?",
    answer:
      "The grammar check feature scans your document for errors and provides suggestions for corrections in real-time.",
    videoUrl: "Grammar.mp4",
    category: "Grammar",
    icon: <SpellcheckIcon />,
  },
  {
    question: "Can I customize the suggestions provided by the grammar check?",
    answer:
      "Yes, you can customize suggestions by adjusting the settings in the references section.",
    category: "Grammar",
    icon: <SettingsIcon />,
  },
  {
    question: "How do I use the paraphrasing tool?",
    answer:
      "Paste your text into the paraphrasing tool and select the paraphrase button to get rewritten content.",
    videoUrl: "ParaphraserVideo.mp4",
    category: "Paraphrasing",
    icon: <AutoAwesomeIcon />,
  },
  {
    question:
      "What options are available for setting the tone in paraphrasing?",
    answer:
      "You can choose from various predefined tones like formal, casual, or professional from the tone settings.",
    videoUrl: "ParaphraserVideo.mp4",
    category: "Paraphrasing",
    icon: <MenuBookIcon />,
  },
  {
    question: "How can I summarize a long document?",
    answer:
      "Upload your document and select the Summarize option to get a concise summary of your content.",
    category: "Summarize",
    icon: <SummarizeIcon />,
  },
  {
    question: "Is it possible to translate documents to multiple languages?",
    answer:
      "Yes, you can translate documents into multiple languages by using the Translator feature and selecting the desired language.",
    category: "Translation",
    icon: <TranslateIcon />,
  },
  {
    question: "How do I navigate to the blogs page?",
    answer:
      "You can find the blogs page in the main menu under the Resources section.",
    category: "Navigation",
    icon: <MenuBookIcon />,
  },
  {
    question: "Can I write and publish my own blogs?",
    answer:
      "Yes, you can write and submit your blogs for approval, and once approved they will be published on the platform.",
    category: "Blogs",
    icon: <DescriptionIcon />,
  },
  {
    question: "How do I create or join a team?",
    answer:
      "Navigate to the Teams page, where you can create a new team or join an existing one by invitation.",
    videoUrl: "TeamsVideo.mp4",
    category: "Teams",
    icon: <GroupIcon />,
  },
  {
    question: "What features are available on the Teams page?",
    answer:
      "The Teams page allows for group chats, document sharing, and collaborative editing.",
    videoUrl: "TeamsVideo.mp4",
    category: "Teams",
    icon: <GroupIcon />,
  },
  {
    question: "How do I check for plagiarism in my document?",
    answer:
      "Upload your document and use the Plagiarism Checks feature to scan for any copied content.",
    videoUrl: "PlagiarismVideo.mp4",
    category: "Plagiarism",
    icon: <PlagiarismIcon />,
  },
  {
    question: "How do I save my document after editing?",
    answer:
      "Click on the Save button in the document editor to save your changes.",
    category: "Documents",
    icon: <DescriptionIcon />,
  },
  {
    question: "Can I download my document after editing it on the platform?",
    answer:
      "Yes, you can download your edited document in various formats like PDF or Word.",
    category: "Documents",
    icon: <DescriptionIcon />,
  },
  {
    question: "How do I get notified about changes or comments on document?",
    answer:
      "Enable notifications in your account settings to receive updates on changes or comments on your document.",
    category: "Notifications",
    icon: <NotificationsIcon />,
  },
  {
    question: "Is there a limit to the number of documents i can upload?",
    answer:
      "There is no limit to the number of documents you can upload; however storage space may vary based on your subscription plan.",
    category: "Documents",
    icon: <UploadFileIcon />,
  },
  {
    question: "How do I access my previously uploaded documents?",
    answer:
      "Go to the My Documents section in your account to access all your uploaded documents.",
    category: "Documents",
    icon: <DescriptionIcon />,
  },
  {
    question: "Can I collaborate with others on a document?",
    answer:
      "Yes, you can share your document with team members and collaborate in real-time.",
    videoUrl: "CoAuthor1Video.mp4",
    category: "Collaboration",
    icon: <GroupIcon />,
  },
  {
    question: "How do I change my account settings?",
    answer:
      "Navigate to Account Settings in the main menu to update your preferences and personal information.",
    category: "Settings",
    icon: <SettingsIcon />,
  },
  {
    question: "Where can I find tutorials or help guides?",
    answer:
      "You can find the blogs page in the main menu under the Resources section.",
    category: "Help",
    icon: <HelpOutlineIcon />,
  },
];

// Group FAQs by category for better organization
const categories = [...new Set(faqData.map((faq) => faq.category))];

const FAQ = () => {
  const [search, setSearch] = useState("");
  const [question, setQuestion] = useState("");
  const [open, setOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [noResultsDialogOpen, setNoResultsDialogOpen] = useState(false);
  const [manualClose, setManualClose] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Bot states
  const [botOpen, setBotOpen] = useState(false);
  const [botMinimized, setBotMinimized] = useState(false);
  const [botMessages, setBotMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isBotTyping, setIsBotTyping] = useState(false);
  const [showGreeting, setShowGreeting] = useState(true);
  const [suggestedQuestions, setSuggestedQuestions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showCategories, setShowCategories] = useState(true);
  const [greetingShown, setGreetingShown] = useState(false);
  const [userName, setUserName] = useState("User"); // This would come from your auth system

  const messagesEndRef = useRef(null);
  const botChatRef = useRef(null);

  // Get current time-based greeting
  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  // Get random welcome messages
  const getWelcomeMessages = () => {
    const messages = [
      `👋 ${getTimeBasedGreeting()}! I'm your AI assistant, ready to help you with any questions about Synthium Spark.`,
      `✨ Welcome back! I'm here to guide you through all the amazing features of Synthium Spark.`,
      `🤖 Hello! Your personal AI assistant is here. How can I make your experience better today?`,
      `💡 Need help? I'm your 24/7 assistant for all things Synthium Spark!`,
      `🌟 Great to see you! Let me help you get the most out of Synthium Spark.`,
    ];
    return messages[Math.floor(Math.random() * messages.length)];
  };

  // Get feature highlights
  const getFeatureHighlights = () => {
    const features = [
      "📝 You can check grammar, paraphrase text, and summarize documents",
      "👥 Create teams and collaborate with others in real-time",
      "🌍 Translate documents to multiple languages",
      "🔍 Check for plagiarism in your content",
      "📚 Access blogs and tutorials in the Resources section",
    ];
    return features[Math.floor(Math.random() * features.length)];
  };

  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();

    const handleStorageChange = () => updateTheme();
    window.addEventListener("storage", handleStorageChange);

    const timer = setTimeout(() => {
      if (!greetingShown) {
        handleBotOpen();

        const savedName = localStorage.getItem("userName") || userName;
        setTimeout(() => {
          addBotMessage(
            `👋 **${getTimeBasedGreeting()}, ${savedName}!**`,
            "bot",
            { isGreeting: true },
          );
        }, 500);

        setTimeout(() => {
          addBotMessage(getWelcomeMessages(), "bot", { isGreeting: true });
        }, 1500);

        setTimeout(() => {
          addBotMessage(`✨ **Quick tip:** ${getFeatureHighlights()}`, "bot", {
            isTip: true,
          });
        }, 3000);

        setTimeout(() => {
          addBotMessage(
            "💬 Feel free to ask me anything about the platform. I'm here to help!",
            "bot",
            { isGreeting: true },
          );
          setSuggestedQuestions(getSuggestedQuestions());
          setGreetingShown(true);
        }, 4500);
      }
    }, 1000);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearTimeout(timer);
    };
  }, []);

  // Get suggested questions based on common topics
  const getSuggestedQuestions = () => {
    return [
      "How do I upload a document?",
      "How does grammar check work?",
      "How can I paraphrase text?",
      "How do I create a team?",
      "How do I check for plagiarism?",
    ];
  };

  const handleBotOpen = () => {
    setBotOpen(true);
    setBotMinimized(false);
  };

  const handleBotClose = () => {
    setBotOpen(false);
    setBotMessages([]);
    setSelectedCategory(null);
    setShowCategories(true);
    setGreetingShown(false);
  };

  const handleBotMinimize = () => {
    setBotMinimized(!botMinimized);
  };

  const addBotMessage = (text, sender, options = {}) => {
    setBotMessages((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        text,
        sender,
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        ...options,
      },
    ]);
  };

  const handleUserInput = (e) => {
    setUserInput(e.target.value);
  };

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;

    // Add user message
    addBotMessage(userInput, "user");
    setUserInput("");
    setIsBotTyping(true);

    // Simulate bot thinking
    setTimeout(() => {
      processUserMessage(userInput);
      setIsBotTyping(false);
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const processUserMessage = (message) => {
    const lowerMessage = message.toLowerCase();

    // Search for relevant FAQ
    const relevantFaqs = faqData.filter(
      (faq) =>
        faq.question.toLowerCase().includes(lowerMessage) ||
        faq.answer.toLowerCase().includes(lowerMessage) ||
        faq.category.toLowerCase().includes(lowerMessage),
    );

    if (relevantFaqs.length > 0) {
      // Show multiple relevant answers
      if (relevantFaqs.length > 1) {
        addBotMessage(
          `🔍 I found ${relevantFaqs.length} relevant answers for you:`,
          "bot",
        );
        relevantFaqs.slice(0, 3).forEach((faq, index) => {
          addBotMessage(
            `${index + 1}. **${faq.question}**\n${faq.answer}`,
            "bot",
            {
              faq: faq,
              actions: faq.videoUrl ? ["watch_video"] : [],
            },
          );
        });
        if (relevantFaqs.length > 3) {
          addBotMessage(
            `📚 And ${relevantFaqs.length - 3} more answers. You can search more in the FAQ section!`,
            "bot",
          );
        }
      } else {
        // Single relevant answer
        const faq = relevantFaqs[0];
        addBotMessage(`📌 **${faq.question}**\n\n${faq.answer}`, "bot", {
          faq: faq,
          actions: faq.videoUrl ? ["watch_video"] : [],
        });
      }
    } else {
      // No relevant answer found
      addBotMessage(
        "🤔 I couldn't find a direct answer to your question. Would you like to:",
        "bot",
        {
          actions: ["ask_human", "search_faq", "browse_categories"],
        },
      );
    }

    // Show feedback options after response
    setTimeout(() => {
      addBotMessage("📊 Was this helpful?", "bot", {
        actions: ["feedback_yes", "feedback_no"],
        isFeedback: true,
      });
    }, 1000);
  };

  const handleSuggestionClick = (suggestion) => {
    setUserInput(suggestion);
    handleSendMessage();
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setShowCategories(false);

    const categoryFaqs = faqData.filter((faq) => faq.category === category);
    addBotMessage(`📑 Here are questions about **${category}**:`, "bot");

    categoryFaqs.forEach((faq, index) => {
      addBotMessage(`${index + 1}. ${faq.question}`, "bot", {
        faq: faq,
        isQuestionLink: true,
        questionIndex: index,
      });
    });

    addBotMessage("👇 Click on any question to see the answer!", "bot");
  };

  const handleQuestionClick = (faq) => {
    addBotMessage(`**${faq.question}**\n\n${faq.answer}`, "bot", {
      faq: faq,
      actions: faq.videoUrl ? ["watch_video"] : [],
    });
  };

  const handleAction = (action, faq = null) => {
    switch (action) {
      case "watch_video":
        if (faq && faq.videoUrl) {
          setVideoUrl(faq.videoUrl);
          setOpen(true);
        }
        break;
      case "ask_human":
        addBotMessage(
          "👤 You can ask your question in the contact form on the right, and our support team will get back to you within 24 hours!",
          "bot",
        );
        // Highlight the contact form
        document
          .querySelector("textarea")
          ?.scrollIntoView({ behavior: "smooth" });
        break;
      case "search_faq":
        addBotMessage(
          "🔎 You can use the search bar above to find more answers in our FAQ section!",
          "bot",
        );
        document
          .querySelector('input[placeholder="Search for answers..."]')
          ?.focus();
        break;
      case "browse_categories":
        setShowCategories(true);
        setSelectedCategory(null);
        addBotMessage("📂 Browse questions by category:", "bot");
        categories.forEach((cat) => {
          addBotMessage(`• ${cat}`, "bot", { category: cat, isCategory: true });
        });
        break;
      case "feedback_yes":
        addBotMessage(
          "👍 Great! I'm glad I could help! Is there anything else you'd like to know?",
          "bot",
        );
        break;
      case "feedback_no":
        addBotMessage(
          "😔 I'm sorry I couldn't help. Would you like to talk to a human support agent?",
          "bot",
        );
        break;
      default:
        break;
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setManualClose(false);
  };

  const handleQuestionChange = (e) => {
    setQuestion(e.target.value);
  };

  const handleOpen = async (fileName) => {
    setVideoUrl(fileName);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setVideoUrl("");
  };

  const handleNodataClose = () => {
    setNoResultsDialogOpen(false);
    setManualClose(true);
  };

  const handleSubmit = async () => {
    if (!question.trim()) {
      alert("Please enter your question.");
      return;
    }

    // Add to bot chat as well
    addBotMessage(`📝 Question submitted to support: "${question}"`, "user");
    addBotMessage(
      "✅ Your question has been submitted! Our support team will get back to you within 24 hours.",
      "bot",
    );

    console.log("Question submitted:", question);
    setQuestion("");
  };

  const filteredFaqs = faqData.filter(
    (faq) =>
      faq.question.toLowerCase().includes(search.toLowerCase()) ||
      faq.answer.toLowerCase().includes(search.toLowerCase()),
  );

  useEffect(() => {
    if (filteredFaqs.length === 0 && search && !manualClose) {
      setNoResultsDialogOpen(true);
    } else {
      setNoResultsDialogOpen(false);
    }
  }, [filteredFaqs, search, manualClose]);

  // Scroll to bottom of messages
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [botMessages]);

  const bgColor = isDarkMode ? "#0a0a0a" : "#f5f7fa";
  const paperBg = isDarkMode
    ? "rgba(18, 18, 18, 0.8)"
    : "rgba(255, 255, 255, 0.85)";
  const textPrimary = isDarkMode ? "#ffffff" : "#1a1a1a";
  const accentColor = "#1976d2";
  const botBg = isDarkMode ? "#1e1e1e" : "#ffffff";

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        overflow: "hidden",
        backgroundColor: bgColor,
      }}
    >
      {/* Original Animated Background - Preserved exactly as in original code */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
      >
        {/* Gradient Base */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: isDarkMode
              ? "radial-gradient(circle at 30% 40%, #1a237e 0%, #000000 80%)"
              : "radial-gradient(circle at 30% 40%, #e3f2fd 0%, #ffffff 80%)",
            opacity: 0.8,
          }}
        />

        {/* Floating Question Marks - Symbolizing FAQs */}
        {[...Array(15)].map((_, i) => (
          <Box
            key={`question-${i}`}
            sx={{
              position: "absolute",
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              fontSize: `${Math.random() * 30 + 20}px`,
              fontWeight: "bold",
              color: isDarkMode
                ? `rgba(25, 118, 210, ${Math.random() * 0.15 + 0.05})`
                : `rgba(25, 118, 210, ${Math.random() * 0.1 + 0.03})`,
              animation: `floatQuestion ${Math.random() * 15 + 15}s infinite ease-in-out`,
              transform: `rotate(${Math.random() * 360}deg)`,
              "@keyframes floatQuestion": {
                "0%": {
                  transform: `translate(0, 0) rotate(0deg) scale(1)`,
                },
                "33%": {
                  transform: `translate(${Math.random() * 60 - 30}px, ${Math.random() * 60 - 30}px) rotate(${Math.random() * 180}deg) scale(${Math.random() * 0.3 + 0.8})`,
                },
                "66%": {
                  transform: `translate(${Math.random() * -60 + 30}px, ${Math.random() * -60 + 30}px) rotate(${Math.random() * -180}deg) scale(${Math.random() * 0.3 + 0.8})`,
                },
                "100%": {
                  transform: `translate(0, 0) rotate(0deg) scale(1)`,
                },
              },
            }}
          >
            ?
          </Box>
        ))}

        {/* Knowledge Connection Lines */}
        <svg
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            opacity: isDarkMode ? 0.15 : 0.1,
          }}
        >
          {[...Array(12)].map((_, i) => {
            const startX = Math.random() * 100;
            const startY = Math.random() * 100;
            const endX = Math.random() * 100;
            const endY = Math.random() * 100;
            return (
              <line
                key={`line-${i}`}
                x1={`${startX}%`}
                y1={`${startY}%`}
                x2={`${endX}%`}
                y2={`${endY}%`}
                stroke={accentColor}
                strokeWidth="1"
                strokeDasharray="5,5"
              >
                <animate
                  attributeName="stroke-dashoffset"
                  from="1000"
                  to="0"
                  dur={`${Math.random() * 20 + 20}s`}
                  repeatCount="indefinite"
                />
              </line>
            );
          })}
        </svg>

        {/* Pulsing Knowledge Nodes */}
        {[...Array(20)].map((_, i) => (
          <Box
            key={`node-${i}`}
            sx={{
              position: "absolute",
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 6 + 4}px`,
              height: `${Math.random() * 6 + 4}px`,
              borderRadius: "50%",
              backgroundColor: accentColor,
              opacity: 0.3,
              animation: `pulseNode ${Math.random() * 4 + 3}s ease-in-out infinite`,
              boxShadow: `0 0 20px ${accentColor}`,
              "@keyframes pulseNode": {
                "0%": {
                  transform: "scale(1)",
                  opacity: 0.2,
                },
                "50%": {
                  transform: "scale(1.5)",
                  opacity: 0.5,
                },
                "100%": {
                  transform: "scale(1)",
                  opacity: 0.2,
                },
              },
            }}
          />
        ))}

        {/* Knowledge Flow Particles */}
        {[...Array(30)].map((_, i) => (
          <Box
            key={`particle-${i}`}
            sx={{
              position: "absolute",
              left: "0%",
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 3 + 2}px`,
              height: `${Math.random() * 3 + 2}px`,
              borderRadius: "50%",
              backgroundColor: accentColor,
              opacity: 0.4,
              animation: `flowParticle ${Math.random() * 15 + 15}s linear infinite`,
              animationDelay: `${Math.random() * 10}s`,
              "@keyframes flowParticle": {
                "0%": {
                  left: "-5%",
                  opacity: 0,
                },
                "10%": {
                  opacity: 0.4,
                },
                "90%": {
                  opacity: 0.4,
                },
                "100%": {
                  left: "105%",
                  opacity: 0,
                },
              },
            }}
          />
        ))}

        {/* Support Icons Background */}
        <Box
          sx={{
            position: "absolute",
            bottom: "10%",
            right: "5%",
            fontSize: "200px",
            color: isDarkMode
              ? "rgba(255,255,255,0.02)"
              : "rgba(25,118,210,0.02)",
            transform: "rotate(-15deg)",
            animation: "rotateIcon 50s linear infinite",
            "@keyframes rotateIcon": {
              "0%": {
                transform: "rotate(-15deg) scale(1)",
              },
              "50%": {
                transform: "rotate(345deg) scale(1.1)",
              },
              "100%": {
                transform: "rotate(-15deg) scale(1)",
              },
            },
          }}
        >
          <HelpOutlineIcon sx={{ fontSize: "inherit" }} />
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: "5%",
            left: "5%",
            fontSize: "150px",
            color: isDarkMode
              ? "rgba(255,255,255,0.02)"
              : "rgba(25,118,210,0.02)",
            transform: "rotate(10deg)",
            animation: "rotateIconReverse 40s linear infinite",
            "@keyframes rotateIconReverse": {
              "0%": {
                transform: "rotate(10deg) scale(1)",
              },
              "50%": {
                transform: "rotate(370deg) scale(0.9)",
              },
              "100%": {
                transform: "rotate(10deg) scale(1)",
              },
            },
          }}
        >
          <QuizIcon sx={{ fontSize: "inherit" }} />
        </Box>

        {/* Wave Effect - Represents Support Flow */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "30%",
            background: `linear-gradient(180deg, transparent 0%, ${accentColor}10 100%)`,
            animation: "wave 8s ease-in-out infinite alternate",
            "@keyframes wave": {
              "0%": {
                transform: "translateY(0) scaleY(1)",
                opacity: 0.3,
              },
              "100%": {
                transform: "translateY(-20px) scaleY(1.2)",
                opacity: 0.6,
              },
            },
          }}
        />
      </Box>

      {/* Main Content */}
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
          py: { xs: 3, md: 4 },
        }}
      >
        <Grid container spacing={{ xs: 3, md: 3 }}>
          {/* Header Section */}
          <Grid xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <QuizIcon sx={{ fontSize: 48, color: accentColor, mr: 2 }} />
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  color: textPrimary,
                  fontSize: { xs: "2rem", md: "2.5rem" },
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                Synthium Spark Support
              </Typography>
            </Box>
            <Typography
              variant="h6"
              sx={{
                color: textPrimary,
                maxWidth: 600,
                mx: "auto",
                textAlign: "center",
              }}
            >
              Find answers, get help, and connect with our support team
            </Typography>
          </Grid>

          {/* FAQ Section */}
          <Grid xs={12} md={6} lg={8}>
            <Fade in timeout={1200}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 2, md: 3 },
                  background: paperBg,
                  backdropFilter: "blur(10px)",
                  borderRadius: 3,
                  border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgb(255, 255, 255)"}`,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 16px 48px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <TextField
                  fullWidth
                  placeholder="Search for answers..."
                  variant="outlined"
                  value={search}
                  onChange={handleSearchChange}
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 3,
                      backgroundColor: isDarkMode
                        ? "rgba(0,0,0,0.3)"
                        : "rgba(255,255,255,0.5)",
                      backdropFilter: "blur(5px)",
                      "& fieldset": {
                        borderColor: isDarkMode
                          ? "rgba(255,255,255,0.1)"
                          : "rgba(0,0,0,0.1)",
                      },
                      "&:hover fieldset": {
                        borderColor: accentColor,
                      },
                      color: textPrimary,
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: accentColor }} />
                      </InputAdornment>
                    ),
                  }}
                />

                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ color: textPrimary }}>
                    Showing {filteredFaqs.length} of {faqData.length} questions
                  </Typography>
                </Box>

                <Box sx={{ maxHeight: "61vh", overflowY: "auto", pr: 1 }}>
                  {filteredFaqs.length > 0
                    ? filteredFaqs.map((faq, index) => (
                        <Fade in key={index} timeout={300 + index * 50}>
                          <Accordion
                            elevation={0}
                            sx={{
                              mb: 2,
                              background: "transparent",
                              border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"}`,
                              borderRadius: "12px !important",
                              "&:before": {
                                display: "none",
                              },
                              "&.Mui-expanded": {
                                borderColor: accentColor,
                                background: isDarkMode
                                  ? "rgba(25,118,210,0.1)"
                                  : "rgba(25,118,210,0.05)",
                              },
                            }}
                          >
                            <AccordionSummary
                              expandIcon={
                                <ExpandMoreIcon sx={{ color: accentColor }} />
                              }
                              sx={{
                                minHeight: 64,
                                "&.Mui-expanded": {
                                  minHeight: 64,
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Box sx={{ color: accentColor }}>
                                  {faq.icon || <HelpOutlineIcon />}
                                </Box>
                                <Typography
                                  sx={{ color: textPrimary, fontWeight: 500 }}
                                >
                                  {faq.question}
                                </Typography>
                              </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Box sx={{ pl: 5 }}>
                                <Typography sx={{ color: textPrimary, mb: 2 }}>
                                  {faq.answer}
                                </Typography>
                                {faq.videoUrl && (
                                  <Button
                                    variant="contained"
                                    startIcon={<PlayCircleOutlineIcon />}
                                    onClick={() => handleOpen(faq.videoUrl)}
                                    sx={{
                                      borderRadius: 2,
                                      textTransform: "none",
                                      backgroundColor: accentColor,
                                      "&:hover": {
                                        backgroundColor: "#1565c0",
                                        transform: "translateY(-2px)",
                                      },
                                    }}
                                  >
                                    Watch Demo
                                  </Button>
                                )}
                              </Box>
                            </AccordionDetails>
                          </Accordion>
                        </Fade>
                      ))
                    : null}
                </Box>
              </Paper>
            </Fade>
          </Grid>

          {/* Contact Section */}
          <Grid xs={12} md={5} lg={4}>
            <Fade in timeout={1400}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, md: 4 },
                  background: paperBg,
                  backdropFilter: "blur(10px)",
                  borderRadius: 3,
                  border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(255,255,255,0.3)"}`,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                  position: "sticky",
                  top: 24,
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 16px 48px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <Box sx={{ textAlign: "center", mb: 3 }}>
                  <Box
                    component="img"
                    src={GotQuestions}
                    alt="Got Questions"
                    sx={{
                      width: "100%",
                      maxWidth: 200,
                      height: "auto",
                      borderRadius: 2,
                      mb: 3,
                      animation: "pulse 3s infinite",
                      "@keyframes pulse": {
                        "0%": { transform: "scale(1)" },
                        "50%": { transform: "scale(1.05)" },
                        "100%": { transform: "scale(1)" },
                      },
                    }}
                  />
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, color: textPrimary, mb: 1 }}
                  >
                    Still Have Questions?
                  </Typography>
                  <Typography variant="body2" sx={{ color: textPrimary }}>
                    Can't find what you're looking for? Send us your question
                    and we'll get back to you.
                  </Typography>
                </Box>

                <TextField
                  fullWidth
                  multiline
                  rows={5}
                  placeholder="Type your question here..."
                  value={question}
                  onChange={handleQuestionChange}
                  sx={{
                    mb: 3,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: isDarkMode
                        ? "rgba(0,0,0,0.3)"
                        : "rgba(255,255,255,0.5)",
                      backdropFilter: "blur(5px)",
                      "& fieldset": {
                        borderColor: isDarkMode
                          ? "rgba(255,255,255,0.1)"
                          : "rgba(0,0,0,0.1)",
                      },
                      "&:hover fieldset": {
                        borderColor: accentColor,
                      },
                      color: textPrimary,
                    },
                  }}
                />

                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  endIcon={<SendIcon />}
                  onClick={handleSubmit}
                  sx={{
                    borderRadius: 2,
                    py: 1.5,
                    textTransform: "none",
                    backgroundColor: accentColor,
                    "&:hover": {
                      backgroundColor: "#1565c0",
                      transform: "translateY(-2px)",
                      boxShadow: `0 8px 16px ${accentColor}40`,
                    },
                  }}
                >
                  Send Question
                </Button>

                <Box
                  sx={{
                    mt: 3,
                    p: 2,
                    background: isDarkMode
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.5)",
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: textPrimary,
                      display: "block",
                      textAlign: "center",
                    }}
                  >
                    💡 We typically respond within 24 hours
                  </Typography>
                </Box>
              </Paper>
            </Fade>
          </Grid>
        </Grid>

        {/* Video Modal */}
        <Modal open={open} onClose={handleClose}>
          <Fade in={open}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                maxWidth: 800,
                bgcolor: paperBg,
                backdropFilter: "blur(10px)",
                borderRadius: 3,
                p: 3,
                outline: "none",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" sx={{ mb: 2, color: textPrimary }}>
                Video Tutorial
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  height: 450,
                  bgcolor: "#000",
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography sx={{ color: "#fff" }}>
                  Video: {videoUrl}
                </Typography>
              </Box>
            </Box>
          </Fade>
        </Modal>

        {/* No Results Modal */}
        <Modal open={noResultsDialogOpen} onClose={handleNodataClose}>
          <Fade in={noResultsDialogOpen}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                maxWidth: 500,
                bgcolor: paperBg,
                backdropFilter: "blur(10px)",
                borderRadius: 3,
                p: 4,
                outline: "none",
                textAlign: "center",
              }}
            >
              <Box
                component="img"
                src={Nodata}
                alt="No Results"
                sx={{ width: 150, height: 150, mx: "auto", mb: 3 }}
              />
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, color: textPrimary, mb: 2 }}
              >
                No Results Found
              </Typography>
              <Typography variant="body1" sx={{ color: textPrimary, mb: 4 }}>
                We couldn't find an answer to your question. Would you like to
                ask us directly?
              </Typography>
              <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
                <Button variant="outlined" onClick={handleNodataClose}>
                  Close
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    handleNodataClose();
                    document.querySelector("textarea")?.focus();
                  }}
                >
                  Ask Question
                </Button>
              </Box>
            </Box>
          </Fade>
        </Modal>

        {/* Bot Chat Widget - Positioned at bottom right */}
        <Slide direction="up" in={botOpen} mountOnEnter unmountOnExit>
          <Box
            ref={botChatRef}
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              zIndex: 9999,
              width: botMinimized ? 60 : 350,
              height: botMinimized ? 60 : 500,
              transition: "all 0.3s ease",
            }}
          >
            {botMinimized ? (
              // Minimized Bot
              <Tooltip title="Open Chat" placement="left">
                <IconButton
                  onClick={() => setBotMinimized(false)}
                  sx={{
                    width: 60,
                    height: 60,
                    bgcolor: accentColor,
                    color: "white",
                    "&:hover": {
                      bgcolor: "#1565c0",
                      transform: "scale(1.1)",
                    },
                    animation: "pulse 2s infinite",
                    "@keyframes pulse": {
                      "0%": {
                        boxShadow: `0 0 0 0 ${accentColor}`,
                      },
                      "70%": {
                        boxShadow: `0 0 0 20px rgba(25, 118, 210, 0)`,
                      },
                      "100%": {
                        boxShadow: `0 0 0 0 rgba(25, 118, 210, 0)`,
                      },
                    },
                  }}
                >
                  <SmartToyIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
            ) : (
              // Expanded Bot Chat
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  bgcolor: botBg,
                  borderRadius: 3,
                  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                  border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    p: 2,
                    bgcolor: accentColor,
                    color: "white",
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <SmartToyIcon />
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      AI Assistant
                    </Typography>
                    <Badge
                      variant="dot"
                      sx={{
                        "& .MuiBadge-badge": {
                          bgcolor: "#4caf50",
                          animation: "pulse 2s infinite",
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <IconButton
                      size="small"
                      onClick={handleBotMinimize}
                      sx={{ color: "white" }}
                    >
                      <MinimizeIcon />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={handleBotClose}
                      sx={{ color: "white" }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>

                {/* Messages Area */}
                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 2,
                    bgcolor: isDarkMode ? "#1e1e1e" : "#f5f5f5",
                  }}
                >
                  {botMessages.map((msg) => (
                    <Box
                      key={msg.id}
                      sx={{
                        display: "flex",
                        justifyContent:
                          msg.sender === "user" ? "flex-end" : "flex-start",
                        mb: 2,
                      }}
                    >
                      {msg.sender === "bot" && (
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            bgcolor: accentColor,
                            mr: 1,
                          }}
                        >
                          <SmartToyIcon sx={{ fontSize: 18 }} />
                        </Avatar>
                      )}
                      <Box
                        sx={{
                          maxWidth: "70%",
                          bgcolor:
                            msg.sender === "user" ? accentColor : "white",
                          color: msg.sender === "user" ? "white" : textPrimary,
                          borderRadius: 2,
                          p: 1.5,
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          ...(msg.isGreeting && {
                            borderLeft: `4px solid ${accentColor}`,
                          }),
                          ...(msg.isTip && {
                            borderLeft: `4px solid #ff9800`,
                          }),
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ whiteSpace: "pre-wrap" }}
                        >
                          {msg.text}
                        </Typography>

                        {/* Message Actions */}
                        {msg.actions && (
                          <Box
                            sx={{
                              mt: 1,
                              display: "flex",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            {msg.actions.includes("watch_video") && (
                              <Button
                                size="small"
                                variant="outlined"
                                startIcon={<PlayCircleOutlineIcon />}
                                onClick={() =>
                                  handleAction("watch_video", msg.faq)
                                }
                                sx={{ fontSize: "0.7rem" }}
                              >
                                Watch Video
                              </Button>
                            )}
                            {msg.actions.includes("ask_human") && (
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => handleAction("ask_human")}
                                sx={{ fontSize: "0.7rem" }}
                              >
                                Ask Human
                              </Button>
                            )}
                            {msg.actions.includes("search_faq") && (
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => handleAction("search_faq")}
                                sx={{ fontSize: "0.7rem" }}
                              >
                                Search FAQ
                              </Button>
                            )}
                            {msg.actions.includes("browse_categories") && (
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() =>
                                  handleAction("browse_categories")
                                }
                                sx={{ fontSize: "0.7rem" }}
                              >
                                Browse Categories
                              </Button>
                            )}
                          </Box>
                        )}

                        {/* Category Links */}
                        {msg.isCategory && (
                          <Box sx={{ mt: 1 }}>
                            <Button
                              size="small"
                              variant="text"
                              onClick={() => handleCategoryClick(msg.category)}
                              sx={{ fontSize: "0.7rem", color: accentColor }}
                            >
                              View {msg.category} Questions →
                            </Button>
                          </Box>
                        )}

                        {/* Question Links */}
                        {msg.isQuestionLink && msg.faq && (
                          <Box sx={{ mt: 1 }}>
                            <Button
                              size="small"
                              variant="text"
                              onClick={() => handleQuestionClick(msg.faq)}
                              sx={{ fontSize: "0.7rem", color: accentColor }}
                            >
                              Show Answer →
                            </Button>
                          </Box>
                        )}

                        {/* Feedback Buttons */}
                        {msg.isFeedback && (
                          <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
                            <IconButton
                              size="small"
                              onClick={() => handleAction("feedback_yes")}
                              sx={{ color: "#4caf50" }}
                            >
                              <ThumbUpIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleAction("feedback_no")}
                              sx={{ color: "#f44336" }}
                            >
                              <ThumbDownIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        )}

                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            mt: 0.5,
                            opacity: 0.7,
                            fontSize: "0.6rem",
                          }}
                        >
                          {msg.timestamp}
                        </Typography>
                      </Box>
                    </Box>
                  ))}

                  {/* Typing Indicator */}
                  {isBotTyping && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 2,
                      }}
                    >
                      <Avatar
                        sx={{ width: 32, height: 32, bgcolor: accentColor }}
                      >
                        <SmartToyIcon sx={{ fontSize: 18 }} />
                      </Avatar>
                      <Box
                        sx={{
                          bgcolor: "white",
                          borderRadius: 2,
                          p: 2,
                          display: "flex",
                          gap: 0.5,
                        }}
                      >
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            bgcolor: accentColor,
                            borderRadius: "50%",
                            animation: "typing 1s infinite",
                          }}
                        />
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            bgcolor: accentColor,
                            borderRadius: "50%",
                            animation: "typing 1s infinite 0.2s",
                          }}
                        />
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            bgcolor: accentColor,
                            borderRadius: "50%",
                            animation: "typing 1s infinite 0.4s",
                          }}
                        />
                      </Box>
                    </Box>
                  )}

                  {/* Suggested Questions */}
                  {suggestedQuestions.length > 0 && botMessages.length < 3 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="caption"
                        sx={{ color: "gray", mb: 1, display: "block" }}
                      >
                        Suggested questions:
                      </Typography>
                      {suggestedQuestions.map((q, index) => (
                        <Chip
                          key={index}
                          label={q}
                          onClick={() => handleSuggestionClick(q)}
                          sx={{
                            m: 0.5,
                            bgcolor: "white",
                            "&:hover": {
                              bgcolor: accentColor,
                              color: "white",
                            },
                          }}
                        />
                      ))}
                    </Box>
                  )}

                  <div ref={messagesEndRef} />
                </Box>

                {/* Categories Browser */}
                {showCategories && !selectedCategory && (
                  <Box
                    sx={{
                      p: 2,
                      borderTop: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ color: "gray", mb: 1, display: "block" }}
                    >
                      Browse by category:
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {categories.slice(0, 6).map((cat, index) => (
                        <Chip
                          key={index}
                          label={cat}
                          size="small"
                          onClick={() => handleCategoryClick(cat)}
                          sx={{
                            bgcolor: "white",
                            "&:hover": {
                              bgcolor: accentColor,
                              color: "white",
                            },
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Input Area */}
                <Box
                  sx={{
                    p: 2,
                    borderTop: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
                  }}
                >
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Type your question..."
                      value={userInput}
                      onChange={handleUserInput}
                      onKeyPress={handleKeyPress}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor: isDarkMode ? "rgba(0,0,0,0.3)" : "white",
                        },
                      }}
                    />
                    <IconButton
                      onClick={handleSendMessage}
                      disabled={!userInput.trim()}
                      sx={{
                        bgcolor: accentColor,
                        color: "white",
                        "&:hover": {
                          bgcolor: "#1565c0",
                        },
                        "&.Mui-disabled": {
                          bgcolor: "gray",
                        },
                      }}
                    >
                      <SendIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Card>
            )}
          </Box>
        </Slide>

        {/* Bot Toggle Button (when closed) */}
        {!botOpen && (
          <Zoom in={!botOpen}>
            <Tooltip title="Need help? Chat with AI Assistant" placement="left">
              <IconButton
                onClick={handleBotOpen}
                sx={{
                  position: "fixed",
                  bottom: 20,
                  right: 20,
                  zIndex: 9999,
                  width: 60,
                  height: 60,
                  bgcolor: accentColor,
                  color: "white",
                  "&:hover": {
                    bgcolor: "#1565c0",
                    transform: "scale(1.1)",
                  },
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%": {
                      boxShadow: `0 0 0 0 ${accentColor}`,
                    },
                    "70%": {
                      boxShadow: `0 0 0 20px rgba(25, 118, 210, 0)`,
                    },
                    "100%": {
                      boxShadow: `0 0 0 0 rgba(25, 118, 210, 0)`,
                    },
                  },
                }}
              >
                <Badge
                  variant="dot"
                  sx={{
                    "& .MuiBadge-badge": {
                      bgcolor: "#4caf50",
                      right: 5,
                      top: 5,
                    },
                  }}
                >
                  <SmartToyIcon sx={{ fontSize: 30 }} />
                </Badge>
              </IconButton>
            </Tooltip>
          </Zoom>
        )}
      </Container>

      {/* Add keyframe animations */}
      <style>
        {`
          @keyframes typing {
            0%, 100% { opacity: 0.3; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.2); }
          }
        `}
      </style>
    </Box>
  );
};

export default FAQ;
